<template>
  <div class="container">
    <!-- 顶部搜索框 -->
    <div class="head">
      <div class="city" @click="openCity">
        <span>{{ cityName || '城市' }}</span>
        <img src="../assets/img/arrow-up-0.png" alt="" />
      </div>
      <div class="search">
        <van-search v-model="queryParams.keyword" shape="round" placeholder="输入品牌/车型" @search="onSearch" style="padding:0;" />
      </div>
      <!-- <div class="user" v-if="this.$store.state.token" @click="toUserPage">我的</div>
      <div class="user" v-else @click="toLoginPage">登录</div> -->
    </div>
    <!-- 广告图 -->
    <div class="banner_bar" :style="{ height: imgHeight + 'px' }">
      <van-swipe class="my-swiper" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in banners" :key="index" @click.native="toWebLink(item.url)">
          <img :src="item.pic" alt="" />
        </van-swipe-item>
      </van-swipe>
    </div>

    <!-- 功能区 -->
    <div class="work">
      <div class="title">
        目前共有 <span>{{ carcount.carcount }}</span> 辆车供你选择
      </div>
      <van-grid :border="false" :column-num="4" style="padding:0px 8px;">
        <van-grid-item class="work_box" v-for="(item, index) in menuList" :key="index" @click="toWorkPage(item.cCode, item.menuParameter)">
          <img :src="item.menuIcon" class="work_img" />
          <span>{{ item.menuName }}</span>
        </van-grid-item>
      </van-grid>
    </div>
    <!-- 隔离区 -->
    <div class="line1"></div>
    <!-- 筛选区 -->
    <div class="condition">
      <van-tabs v-model="active">
        <!-- 品牌 -->
        <van-tab title="品牌" class="brand"
          ><van-grid :border="false" :column-num="4" style="padding:0px 8px;">
            <van-grid-item class="brand_box" v-for="item in hotBrands" :key="item.id" @click="toBuyCar('brand', item.id, item.name)">
              <van-image :src="item.logoImg" class="brand_img" />
              <span>{{ item.name }}</span>
            </van-grid-item>
          </van-grid>
        </van-tab>
        <!-- 价格 -->
        <van-tab title="价格">
          <van-grid :border="false" :column-num="4">
            <van-grid-item class="price_box" v-for="item in carPrices" :key="item.id" @click="toBuyCar('price', item.value)">
              <span>{{ item.text }}</span>
            </van-grid-item>
          </van-grid>
        </van-tab>
        <!-- 车型 -->
        <van-tab title="车型"
          ><van-grid :border="false" :column-num="4">
            <van-grid-item class="car_type_box" v-for="item in hotModels" :key="item.id" @click="toBuyCar('vehicleType', item.value)">
              <span>{{ item.text }}</span>
            </van-grid-item>
          </van-grid></van-tab
        >
      </van-tabs>
      <div class="more" @click="toMoreCar">全部车源 >></div>
      <div class="list_type">
        <div v-for="(item, index) in specialAreaList" :key="index" @click="toBuyCar('certifyTag', item.value)">
          <img :src="item.iconCls" alt="" />
          <span>{{ item.text }}</span>
        </div>
      </div>
    </div>
    <!-- 隔离区 -->
    <div class="line1" v-if="marketNo != 'sy_longxin'"></div>
    <!-- 列表区 -->
    <div class="car_list" v-if="marketNo != 'sy_longxin'">
      <div class="title">
        <h3>认证车源</h3>
      </div>
      <van-cell v-for="item in listCertifyCar" :key="item.tradeId" style="line-height:14px" @click="toCarDetailPage(item.tradeId)">
        <div class="car_box">
          <div class="car_left">
            <img v-if="item.coverUrl" :src="item.coverUrl" />
            <img v-else lazy-load src="../assets/img/default-car.png" />
          </div>
          <div class="car_right">
            <div class="car_name" v-if="item.brandName || item.seriesName">
              <span>{{ item.brandName || '' }}{{ item.seriesName || '' }}</span>
            </div>
            <div class="car_name" v-if="item.kindName">
              <span>{{ item.kindName || '' }}</span>
            </div>
            <div class="car_info">
              <span>{{ item.registMonth || '未' }}上牌 </span>
              <span v-if="item.mileageCount && item.mileageCount != 'null'"> | {{ item.mileageCount }}万公里</span>
            </div>
            <div class="car_price">
              <span v-if="item.showPrice">{{ isNumber(item.showPrice) ? item.showPrice + '万' : item.showPrice }}</span>
              <span v-if="item.downPayments">首付{{ item.downPayments }}万</span>
            </div>
          </div>
        </div>
      </van-cell>
    </div>
    <!-- 隔离区 -->
    <div class="line1"></div>
    <!-- 列表区 -->
    <div class="car_list">
      <div class="title">
        <h3>超值特惠</h3>
      </div>
      <van-cell v-for="item in listGreatDealCar" :key="item.tradeId" style="line-height:14px" @click="toCarDetailPage(item.tradeId)">
        <div class="car_box">
          <div class="car_left">
            <img v-if="item.coverUrl" :src="item.coverUrl" />
            <img v-else lazy-load src="../assets/img/default-car.png" />
          </div>
          <div class="car_right">
            <div class="car_name" v-if="item.brandName || item.seriesName">
              <span>{{ item.brandName || '' }}{{ item.seriesName || '' }}</span>
            </div>
            <div class="car_name" v-if="item.kindName">
              <span>{{ item.kindName || '' }}</span>
            </div>
            <div class="car_info">
              <span>{{ item.registMonth || '未' }}上牌 </span>
              <span v-if="item.mileageCount && item.mileageCount != 'null'"> | {{ item.mileageCount }}万公里</span>
            </div>
            <div class="car_price">
              <span v-if="item.showPrice">{{ isNumber(item.showPrice) ? item.showPrice + '万' : item.showPrice }}</span>
              <span v-if="item.downPayments">首付{{ item.downPayments }}万</span>
            </div>
          </div>
        </div>
      </van-cell>
    </div>
    <!-- 隔离区 -->
    <div class="line1"></div>
    <!-- 列表区 -->
    <div class="car_list">
      <div class="title">
        <h3>最新车源</h3>
      </div>
      <van-cell v-for="item in listLatestCar" :key="item.tradeId" style="line-height:14px" @click="toCarDetailPage(item.tradeId)">
        <div class="car_box">
          <div class="car_left">
            <img v-if="item.coverUrl" :src="item.coverUrl" />
            <img v-else lazy-load src="../assets/img/default-car.png" />
          </div>
          <div class="car_right">
            <div class="car_name" v-if="item.brandName || item.seriesName">
              <span>{{ item.brandName || '' }}{{ item.seriesName || '' }}</span>
            </div>
            <div class="car_name" v-if="item.kindName">
              <span>{{ item.kindName || '' }}</span>
            </div>
            <div class="car_info">
              <span>{{ item.registMonth || '未' }}上牌 </span>
              <span v-if="item.mileageCount && item.mileageCount != 'null'"> | {{ item.mileageCount }}万公里</span>
            </div>
            <div class="car_price">
              <span v-if="item.showPrice">{{ isNumber(item.showPrice) ? item.showPrice + '万' : item.showPrice }}</span>
              <span v-if="item.downPayments">首付{{ item.downPayments }}万</span>
            </div>
          </div>
        </div>
      </van-cell>
      <div class="more" @click="toMoreCar">查看更多车源 >></div>
    </div>
    <!-- 隔离区 -->
    <div class="line1" v-if="marketNo == 'sy_longxin'"></div>
    <!-- 列表区 -->
    <div class="car_list" v-if="marketNo == 'sy_longxin'">
      <div class="title">
        <h3>认证车源</h3>
      </div>
      <van-cell v-for="item in listCertifyCar" :key="item.tradeId" style="line-height:14px" @click="toCarDetailPage(item.tradeId)">
        <div class="car_box">
          <div class="car_left">
            <img v-if="item.coverUrl" :src="item.coverUrl" />
            <img v-else lazy-load src="../assets/img/default-car.png" />
          </div>
          <div class="car_right">
            <div class="car_name" v-if="item.brandName || item.seriesName">
              <span>{{ item.brandName || '' }}{{ item.seriesName || '' }}</span>
            </div>
            <div class="car_name" v-if="item.kindName">
              <span>{{ item.kindName || '' }}</span>
            </div>
            <div class="car_info">
              <span>{{ item.registMonth || '未' }}上牌 </span>
              <span v-if="item.mileageCount && item.mileageCount != 'null'"> | {{ item.mileageCount }}万公里</span>
            </div>
            <div class="car_price">
              <span v-if="item.showPrice">{{ isNumber(item.showPrice) ? item.showPrice + '万' : item.showPrice }}</span>
              <span v-if="item.downPayments">首付{{ item.downPayments }}万</span>
            </div>
          </div>
        </div>
      </van-cell>
    </div>

    <!-- 页脚 -->
    <page-footer></page-footer>

    <!-- 城市弹出层 -->
    <van-popup v-model="cityBoxShow" class="city_box">
      <div class="row" v-for="(item, index) in this.cityList" :key="index" @click="cityChange(item.value)">
        <span>{{ item.text }}</span>
        <!-- <img v-if="queryParams.city == item.value" src="../assets/img/confirm.png" alt="" /> -->
        <van-icon v-if="queryParams.city == item.value" name="success" color="#1989fa" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import menu from '../utils/menu'
export default {
  data() {
    return {
      title: '',
      userId: '',
      active: 0,
      banners: [], //广告
      menuList: [],
      hotBrands: [],
      carPrices: [],
      hotModels: [],
      carList: [],
      specialAreaList: [],
      queryParams: {
        pageNo: 1,
        pageSize: 8,
        orders: 0,
        price: 0,
        priceLow: '',
        priceHigh: '',
        vehicleType: 0,
        keyword: '',
        mileage: 0,
        mileageCountLow: '',
        mileageCountHigh: '',
        carAge: 0,
        carAgeLow: '',
        carAgeHigh: '',
        certifyTag: 0,
        city: '',

        brand: '',
        series: ''
      },

      listCertifyCar: [],
      listGreatDealCar: [],
      listLatestCar: [],

      cityBoxShow: false,
      cityList: [],
      carcount: '',
      marketNo: ''
    }
  },
  created() {
    var width = window.getComputedStyle(document.getElementById('app')).width
    this.imgHeight = width.substring(0, 3) / 2.5
    this.queryParams.city = this.$store.state.city

    this.getMarketNo()

    this.findIndexInfo()
    this.getBanners()
    this.gethotBrands()
    this.getCommonBox()

    // 认证车源
    this.getListCertifyCar()

    // 超值特惠
    this.getListGreatDealCar()

    // 最新车源
    this.getListLatestCar()

    this.getCarcount() // 车总数

    // 城市
    this.getCityList()

    // 菜单
    this.getMenuList()
  },
  methods: {
    isNumber(obj) {
      return typeof obj === 'number' && !isNaN(obj)
    },
    async getMarketNo() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/vehicle/getMarketNo')
      if (data.success) {
        this.marketNo = data.data.info.marketNo
      }
    },
    async getCityList() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/config/listArea')
      if (data.success) {
        this.cityList = data.data.list
      }
    },
    async findIndexInfo() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/index/findIndexInfo')
      if (data.success) {
        this.marketInfo = data.data.info
        document.title = this.marketInfo.sitename
        this.$store.commit('setMarketInfo', this.marketInfo)
      }
    },
    async getBanners() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/index/banners', {
        params: {
          type: 2
        }
      })
      if (data.success) {
        this.banners = data.data.list
      }
    },
    async gethotBrands() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/config/hotBrands')
      if (data.success) {
        this.hotBrands = data.data.list
      }
    },
    async getCommonBox() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/config/commonBox', {
        params: {
          selectCode: 'carPrice,hotModel,specialArea'
        }
      })
      if (data.success) {
        this.carPrices = data.data.carPrice
        this.specialAreaList = data.data.specialArea
        this.hotModels = data.data.hotModel
      }
    },
    async getCarcount() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/index/carcount')
      if (data.success) {
        this.carcount = data.data
      }
    },
    async getListCertifyCar() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/index/listCertifyCar?city=' + this.queryParams.city)
      if (data.success) {
        data.data.page.rows.forEach(item => {
          if (!item.registMonth) {
            item.registMonth = '未'
          }
          if (!item.regionName) {
            item.regionName = ''
          }
        })
        this.listCertifyCar = data.data.page.rows
      }
    },
    async getListGreatDealCar() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/index/listGreatDealCar?city=' + this.queryParams.city)
      if (data.success) {
        data.data.page.rows.forEach(item => {
          if (!item.registMonth) {
            item.registMonth = '未'
          }
          if (!item.regionName) {
            item.regionName = ''
          }
        })
        this.listGreatDealCar = data.data.page.rows
      }
    },
    async getListLatestCar() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/index/listLatestCar?city=' + this.queryParams.city)
      if (data.success) {
        data.data.page.rows.forEach(item => {
          if (!item.registMonth) {
            item.registMonth = '未'
          }
          if (!item.regionName) {
            item.regionName = ''
          }
        })
        this.listLatestCar = data.data.page.rows
      }
    },
    async getMenuList() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/menu/menuList?kindId=2')
      if (data.success) {
        var menuList = []
        for (var item of data.data.page) {
          for (var key in menu.menus) {
            if (item.cCode == key) {
              menuList.push(item)
            }
          }
        }
        this.menuList = menuList
        window.sessionStorage.setItem('menuList', JSON.stringify(this.menuList))
      }
    },
    cityChange(value) {
      this.queryParams.city = value
      this.$store.commit('setCity', value)
      this.cityBoxShow = false
      // 认证车源
      this.getListCertifyCar()

      // 超值特惠
      this.getListGreatDealCar()

      // 最新车源
      this.getListLatestCar()
    },
    onSearch() {
      this.$router.push({
        path: '/buy-car',
        query: {
          keyword: this.queryParams.keyword
        }
      })
    },
    toLoginPage() {
      this.$router.push({
        path: '/login'
      })
    },
    toUserPage() {
      this.$router.push({
        path: '/user'
      })
    },
    // 功能页
    toWorkPage(name, menuParameter) {
      if (name == 'YuanTongAuction') {
        // 拍卖
        window.open('https://www.ytpai.com')
      } else {
        this.$router.push({
          path: menu.menus[name],
          query: {
            pageId: menuParameter
          }
        })
      }
    },
    toBuyCar(params, value, name) {
      this.$router.push({
        path: '/buy-car',
        query: {
          [params]: value,
          brandName: name || ''
        }
      })
    },
    // 更多车
    toMoreCar() {
      this.$router.push({
        path: '/buy-car',
        query: {}
      })
    },
    toCarDetailPage(id) {
      this.$router.push({
        path: '/car-detail',
        query: {
          tradeId: id
        }
      })
    },
    // 打开城市
    openCity() {
      this.cityBoxShow = true
    },
    // 跳转图片链接
    toWebLink(url) {
      window.open(url)
    }
  },
  computed: {
    cityName() {
      var index = this.cityList.findIndex(item => item.value == this.$store.state.city)
      if (index != -1) {
        return this.cityList[index].text
      }
      return ''
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
}
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  padding: 0 20px;
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 999;
  .city {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 15px;
      height: 15px;
      margin-left: 8px;
    }
  }
}
.banner_bar {
  width: 3.75rem;
  height: 1.29rem;
  box-sizing: border-box;
  .my-swiper {
    height: 100%;
    width: 100%;
    background-color: #ddd;
  }
  .van-swipe-item {
    height: 100%;
    width: 100%;
    .van-swipe__track {
      height: 100%;
      width: 100%;
    }
  }
}

.work {
  .title {
    text-align: center;
    line-height: 2;
    span {
      font-size: 24px;
      color: #22b7ff;
    }
  }
  .work_box {
    .work_img {
      width: 0.4rem;
      height: 0.4rem;
    }
  }
}
.condition {
  .brand {
    .brand_box {
      display: flex;
      flex-direction: column;
      color: #757a7e;
      .brand_img {
        width: 0.45rem;
        height: 0.4rem;
      }
    }
  }
  .more {
    background-color: #1989fa;
    width: 3.21rem;
    height: 0.33rem;
    line-height: 0.33rem;
    margin: 0 auto;
    text-align: center;
    border-radius: 6px;
    color: #fff;
  }
  .list_type {
    height: 1rem;
    display: flex;
    flex-wrap: wrap;
    margin-top: 0.2rem;
    div {
      width: 25%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        height: 0.5rem;
        width: 0.5rem;
      }
      span {
        margin-top: 5px;
      }
    }
  }
}

.line1 {
  margin-top: 0.1rem;
  height: 0.14rem;
  background-color: #f2f2f2;
}
.price_box {
  color: #757a7e;
}

.car_type_box {
  color: #757a7e;
}

.car_list {
  .title {
    text-align: center;
    color: #000;
    border-bottom: 1px solid #cccccc;
  }
  .car_box {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 0.8rem;
    .car_left {
      width: 35%;
      height: 100%;
    }
    .car_right {
      width: 60%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      .car_name {
        height: 16px;
        font-size: 14px;
        font-weight: 700;
        line-height: 16px;
        white-space: nowrap; /*超出的空白区域不换行*/
        overflow: hidden; /*超出隐藏*/
        text-overflow: ellipsis;
      }
      .car_info {
        font-size: 14px;
        color: #888;
      }
      .car_price {
        font-size: 14px;
        color: #888;
        display: flex;
        justify-content: space-between;
        & span:nth-of-type(2) {
          font-size: 16px;
          color: #f37420;
        }
      }
    }
  }
  .more {
    background-color: #1989fa;
    width: 3.21rem;
    height: 0.33rem;
    line-height: 0.33rem;
    margin: 20px auto 0;
    text-align: center;
    border-radius: 6px;
    color: #fff;
  }
}

// city
.city_box {
  height: 85%;
  width: 85%;
  margin: 0 auto;
  padding: 0 10px;
  .row {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f2f2f2;
    img {
      width: 26px;
      height: 26px;
    }
  }
}
</style>
